// src/context/UnsavedChangesContext.js

import { useState, useContext, createContext } from "react"
import React from "react";

const UnsavedChangesContext = createContext()

export const UnsavedChangesProvider = ({ children }) => {
  const [isUnsaved, setIsUnsaved] = useState(false)

  return (
    <UnsavedChangesContext.Provider
      value={{ isUnsaved, setIsUnsaved }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  )
}

export const useUnsavedChanges = () => useContext(UnsavedChangesContext)
